import type {
  Credit,
  FinanceType,
  Job,
  Payment,
} from "@kanda-libs/ks-frontend-services";
import type { PaymentWithFinanceType } from "./types";

export const getCreditForPayment = (payment: Payment, credits: Credit[]) =>
  credits.find((credit) => credit.kid === payment.kid);

const sortJobPayments = (
  payments: PaymentWithFinanceType[]
): PaymentWithFinanceType[] => {
  if (!payments || payments.length === 0) {
    return [];
  }

  return [...payments].sort((p1, p2) => {
    const p1Date = p1?.metadata?.updated_at || p1?.metadata?.created_at;
    const p2Date = p2?.metadata?.updated_at || p2?.metadata?.created_at;

    if (!p1Date || !p2Date) throw new Error("Payment date is missing");

    return p1Date.getTime() - p2Date.getTime();
  });
};

export const jobToPaymentsWithFinanceType = (
  job?: Job
): PaymentWithFinanceType[] => {
  if (!job || !job.payments || job.payments.length === 0) {
    return [];
  }

  const financeTypes =
    job?.customer_options?.finance_option?.finance_types || [];

  const isSecondary =
    financeTypes.length > 0 &&
    !!financeTypes.find((type) => type === "secondary");

  const countOfPayments = job.payments.length;

  const paymentsWithFinanceTypes = job.payments.map((payment, key) => {
    const isLastTwoPayments =
      key === countOfPayments - 1 || key === countOfPayments - 2;

    const financeType = !isSecondary
      ? "primary"
      : isLastTwoPayments
      ? "secondary"
      : "primary";

    return {
      ...payment,
      finance_type: financeType as FinanceType,
    };
  });

  return sortJobPayments(paymentsWithFinanceTypes);
};
